import React from 'react';
import Popup from 'reactjs-popup';
import { Button } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import homeStyles from '../Home.module.css';
import styles from './EditHoursButton.module.css';

const EditHoursButton = (props) => (
  <Popup
    position="bottom center"
    trigger={
      <Button
        className={homeStyles.dateRangeButton}
        variant="contained"
        startIcon={<SettingsIcon />}
      >
        Meal Hours
      </Button>
    }
  >
    {(close) => (
      <div className={styles.popupContent}>
        <form name="mealhours">
          <h3>Edit meal start times</h3>
          <table>
            <tbody>
              <tr>
                <td>Breakfast:</td>
                <td>
                  <input
                    type="time"
                    name="breakfast"
                    defaultValue={props.breakfast}
                  />
                </td>
              </tr>
              <tr>
                <td>Lunch:</td>
                <td>
                  <input type="time" name="lunch" defaultValue={props.lunch} />
                </td>
              </tr>
              <tr>
                <td>Dinner:</td>
                <td>
                  <input
                    type="time"
                    name="dinner"
                    defaultValue={props.dinner}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div className={styles.saveBtn}>
            <input
              type="submit"
              name="Save"
              value="Save"
              onClick={(event) => {
                props.validator(event, document.mealhours);
                close();
              }}
            />
          </div>
        </form>
      </div>
    )}
  </Popup>
);

export default EditHoursButton;
